/**
                          use proper naming convention with declartaion of variable where we can use snakecase var where we have to use camel case var decalrtion
                      also try to optimize the code more with exception handling	
                      **/

"use strict";
const email_pattern = /^[a-zA-Z0-9\_\.\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z]+)$/;
const number_pattern = /^-?\d+$/;
const string_pattern = /^[a-zA-Z]/;
const obj_status = {
  first_name_status: "",
  last_name_status: true,
  email_status: "",
  phone_status: "",
  password_status: "",
  confirm_passoword_status: "",
};
let check_validation,
  error_msg,
  submitBtn,
  Status = "false";

let init = () => {
  let form_selectors = {
    login_form: document.querySelector('[action="/account/login"]'),
    create_form: document.querySelector('[action="/account"]'),
    contact_form: document.querySelector('[action="/contact#ContactForm"]'),
    address_form: document.querySelector('[action="/account/addresses"]'),
  };
  let Input = document.querySelectorAll("input");
  Input.forEach(function (Item, Index) {
    Item.addEventListener("keyup", Validation.bind(this));
    Item.addEventListener("input", Validation.bind(this));
    Item.addEventListener("focus", Validation.bind(this));
    Item.btn = form_selectors;
  });
};
let Validation = (evt) => {
  let evtTarget = evt.target;
  let inputType = evtTarget.type;
  switch (inputType) {
    case "email":
      check_validation = email_pattern.test(evtTarget.value);
      check_validation == true
        ? ((obj_status.email_status = true),
          Remove_Element(evtTarget))
        : ((obj_status.email_status = false),
          Create_Element(evtTarget, inputType));
      break;
    case "password":
      evtTarget.value.length < 5
        ? ((obj_status.password_status = false),
          Create_Element(evtTarget, evtTarget.type))
        : ((obj_status.password_status = true),
          Remove_Element(evtTarget));
      break;
    case "text":
      if (
        evtTarget.name == "customer[first_name]" ||
        evtTarget.name == "contact[name]" ||
        evtTarget.name == "address[first_name]"
      ) {
        string_pattern.test(evtTarget.value) == true &&
        evtTarget.value.length > 0
          ? ((obj_status.first_name_status = true),
            Remove_Element(evtTarget))
          : ((obj_status.first_name_status = false),
            Create_Element(evtTarget, evtTarget.type))
      } else if (
        evtTarget.name == "customer[last_name]" ||
        evtTarget.name == "address[last_name]"
      ) {
        if (evtTarget.value.length > 0) {
          string_pattern.test(evtTarget.value) == false
            ? ((obj_status.last_name_status = false),
              Create_Element(evtTarget, evtTarget.type))
            : ((obj_status.last_name_status = true),
              Remove_Element(evtTarget));
        } else {
          obj_status.last_name_status = true;
          Remove_Element(evtTarget);
        }
      }
      break;
    case "tel":
      number_pattern.test(evtTarget.value) == false
        ? ((obj_status.phone_status = false),
          Create_Element(evtTarget, evtTarget.type))
        : ((obj_status.phone_status = true),
          Remove_Element(evtTarget));
      break;
    default:
      console.log("default", box_name);
  }
};

// created span tag

let Create_Element = (ele, name_type) => {
  console.log(ele.value.length,"length");
  if (ele.value.length > 0) {
    if (
      ele.nextElementSibling == null ||
      ele.nextElementSibling.tagName != "SPAN"
    ) {
      let element = document.createElement("SPAN");
      element.setAttribute("style", "color:red");
      element.setAttribute("class", name_type);
      element.classList.add("custom_error");
      if (name_type == "email") {
        element.textContent = "Invalid Email Address";
      } else if (name_type == "password") {
        element.textContent = "Password cannot be less than 5 characters";
      } else if (name_type == "text") {
        ele.name == "customer[first_name]"
          ? (element.textContent = "First name cannot be empty")
          : ele.name == "address[first_name]"
          ? (element.textContent = "First name cannot be empty")
          : ele.name == "address[last_name]"
          ? (element.textContent = "Last name must be start with string")
          : ele.name == "customer[last_name]"
          ? (element.textContent = "Last name must be start with string")
          : ele.name == "contact[name]"
          ? (element.textContent = "Name cannot be empty")
          : console.log();
      } else if (name_type == "tel") {
        element.textContent = "Phone number cannot be empty";
      }
      ele.after(element);
    } else if (ele.nextElementSibling.tagName == "SPAN") {
      console.log(ele.name);
      if (ele.value.length == 0 && ele.name == "customer[first_name]") {
        ele.nextElementSibling.textContent = "First name must cannot be empty";
      } else if (ele.value.length == 0 && ele.name == "customer[last_name]") {
        ele.nextElementSibling.remove();
      } else if (ele.value.length == 0 && ele.name == "address[last_name]") {
        ele.nextElementSibling.remove();
      } else if (ele.value.length > 0 && ele.name == "customer[first_name]") {
        ele.nextElementSibling.textContent =
          "First name must be start with string";
      } else if (ele.value.length == 0 && ele.name == "contact[Name]") {
        ele.nextElementSibling.textContent = "Name cannot be empty";
      } else if (ele.value.length > 0 && ele.name == "address[first_name]") {
        ele.nextElementSibling.textContent =
          "First name must be start with string";
      } else if (ele.value.length > 0 && ele.name == "contact[Name]") {
        ele.nextElementSibling.textContent = "Name must be start with string";
      } else if (ele.value.length > 0 && name_type == "tel") {
        ele.nextElementSibling.textContent = "Phone number must be a number";
      } else if (ele.value.length == 0 && name_type == "tel") {
        ele.nextElementSibling.textContent = "Phone number cannot be empty";
      }
    }
  } else if (ele.value.length == 0 || ele.value.length == '') {
    if (ele.parentNode.querySelector(".custom_error") != null) {
      ele.parentNode.querySelector(".custom_error").remove();
    }
  }
};
// Remove Error Message Element

let Remove_Element = (ele) => {
  console.log(ele);
  let dynamicClass = ele.nextElementSibling;
  if (dynamicClass != undefined) {
    let dynamicClassAttribute = dynamicClass.getAttribute("class");
    if (dynamicClassAttribute.includes(ele.type)) {
      ele.nextElementSibling.tagName == "SPAN"
        ? ele.nextElementSibling.remove()
        : console.log();
    }
  }
};

init();
function onlyNumberKey(evt) {
  // Only ASCII character in that range allowed
  var ASCIICode = evt.which ? evt.which : evt.keyCode;
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
  return true;
} 


